const canIUseSessonStorage = typeof sessionStorage !== 'undefined';

export const LOCAL_SHUMEI_SM_SDK_DEVICE_ID_KEY = 'shumei_sm_sdk_device_id';

const _getShuMeiSDKDeviceId = (): string | undefined => {
  if (canIUseSessonStorage) {
    const _id = sessionStorage.getItem(LOCAL_SHUMEI_SM_SDK_DEVICE_ID_KEY);
    if (_id) {
      return _id;
    }

    if (typeof SMSdk !== 'undefined') {
      const id = SMSdk?.getDeviceId();
      if (id) {
        sessionStorage.setItem(LOCAL_SHUMEI_SM_SDK_DEVICE_ID_KEY, id);
        return id;
      }
    }
    return undefined;
  }
  return SMSdk?.getDeviceId();
};

export const getShuMeiSDKDeviceId = () => {
  const _id = _getShuMeiSDKDeviceId();
  if (typeof _id === 'string' && _id.length > 3000) {
    return _id.substring(0, 3000);
  }
  return _id;
};

export const getShuMeiSDKVdata = (): any | undefined => {
  if (typeof SMVdataSDK !== 'undefined') {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
    const vdata = SMVdataSDK.getVdata?.();
    if (vdata) {
      return vdata;
    }
  }
  return undefined;
};

export type ShuMeiSMCaptchaResult = {
  rid: string;
  pass: boolean;
  close?: boolean;
};

export type ShuMeiSMCaptchaOptions = ShuMeuSMCaptcha.Options;

export const ShuMeiSMCaptchaModeMap: Record<string, ShuMeiSMCaptchaOptions['mode']> = {
  '1': 'slide',
  '2': 'select',
  '3': 'icon_select',
  '4': 'seq_select',
  '5': 'spatial_select',
};

export function createShuMeiCaptchaPromise(options?: Partial<ShuMeiSMCaptchaOptions>): Promise<ShuMeiSMCaptchaResult> {
  return new Promise<ShuMeiSMCaptchaResult>((resolve, reject) => {
    const defaultOptions: Partial<ShuMeiSMCaptchaOptions> = {
      organization: 'qvdTr7A9k1DIU04ha4eP',
      appId: 'default',
      product: 'popup',
      mode: 'slide',
      lang: 'zh-cn',
      width: '80%',
    };
    const mergedOptions: ShuMeiSMCaptchaOptions = { ...defaultOptions, ...options } as ShuMeiSMCaptchaOptions;

    if (!mergedOptions.organization) {
      return reject(new Error('参数错误'));
    }

    if ((mergedOptions.product === 'embed' || mergedOptions.product === 'float') && !mergedOptions.appendTo) {
      return reject(new Error('参数错误'));
    }

    try {
      if (typeof initSMCaptcha === 'undefined' || typeof initSMCaptcha !== 'function') {
        return reject(new Error('验证码资源调用失败'));
      }

      initSMCaptcha(mergedOptions, function (SMCaptcha) {
        SMCaptcha.onSuccess(function (data: ShuMeiSMCaptchaResult) {
          if (data.pass) {
            resolve(data);
          }
        });

        SMCaptcha.onError(function (errType: string, errMsg: { code: number; message: string }) {
          reject({
            type: errType,
            message: errMsg,
          });
        });
        SMCaptcha.onClose(function () {
          resolve({ rid: '', pass: false, close: true });
        });

        SMCaptcha.onReady(function (rootEl, params) {
          console.log('initSMCaptcha-onReady', params);

          if (mergedOptions.product === 'popup') {
            setTimeout(() => {
              SMCaptcha.verify();
            }, 0);
          }
        });
      });
    } catch (error) {
      reject(error);
    }
  });
}
